import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    SetKixieIntegrationIsEnabled as SetKixieIntegrationIsEnabledMutation,
    SetKixieIntegrationIsEnabledVariables,
} from 'nutshell-graphql-types';

import GET_SESSION_USER from '../../../../core/graphql/queries/get-session-user.graphql';

import SET_KIXIE_INTEGRATION_IS_ENABLED from '../mutations/set-kixie-integration-is-enabled.graphql';

export const useSetKixieIntegrationIsEnabled = (): {
    setKixieIntegrationIsEnabled: (isEnabled: boolean) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [setKixieIntegrationIsEnabled, {loading, error}] = useMutation<
        SetKixieIntegrationIsEnabledMutation,
        SetKixieIntegrationIsEnabledVariables
    >(SET_KIXIE_INTEGRATION_IS_ENABLED, {refetchQueries: [{query: GET_SESSION_USER}]});

    return {
        setKixieIntegrationIsEnabled: (isEnabled: boolean) =>
            setKixieIntegrationIsEnabled({variables: {isEnabled}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
